import Vue from 'vue';
import Vuex, { Commit } from 'vuex';
import storeConstants from '@/utils/constants/StoreConstants'
import { UserModel } from '@/user/models/UserModel';
import userService from '@/user/services/UserService'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAuthenticated: new UserModel(),
  },
  getters: {
    userAuthenticated(state) {
      return state.userAuthenticated
    },
  },
  mutations: {
    [storeConstants.mutations.SET_AUTHENTICATED_USER](state, user) {
      state.userAuthenticated = user
    },    
  },
  actions: {
    async [storeConstants.actions.GET_AUTHENTICATED_USER]({commit}) {
      return userService.getUserAuthenticated()
        .then((user) => {
          commit(storeConstants.mutations.SET_AUTHENTICATED_USER, user)
        })
    },    
  },
});
